export default {
  name: 'ACTIVATE_COLLAPSE',
  fields: {
    category: 'Activate Collapse', // page
    action: '', // open|close
    label: '', // button label
    value: 0,
    nonInteraction: false
  }
}



// WEBPACK FOOTER //
// ./src/analytics/Events/Collapse.js